import { Button, DataGrid, ScrollView } from "devextreme-react";
import { Column } from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import notify from "devextreme/ui/notify";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "../../../components";
import { getApiParams } from "../../../redux/auth";
import { BodyType, createRequest } from "../../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../../redux/base/types/saga";
import { getLocalized } from "../../../redux/localization";
import BaseService from "../../../services";
import { adminPendingContacts } from "../../../services/urls";
import { CompleteContact } from "../../contact/type";
import PendingContactsDetail from "./detail";
import { PendingContacts } from "./type";

const PendingContact = () => {
  const localize = useSelector(getLocalized);
  const baseService = new BaseService();
  const tableRef = useRef<any>();
  const { token, lang } = useSelector(getApiParams);
  const [show, setShow] = useState(false);
  const completedId = useRef<CompleteContact>({
    contactId: "",
  });
  const [data, setData] = useState<PendingContacts>({
    Email: "",
    Id: "",
    isCompleted: false,
    Message: "",
    Name: "",
    Phone: "",
    Surname: "",
  });
  const columns = [
    {
      dataField: "Name",
      caption: localize.getString("name"),
    },
    {
      dataField: "Surname",
      caption: localize.getString("surname"),
    },
    {
      dataField: "Email",
      caption: localize.getString("email"),
    },
    {
      dataField: "Phone",
      caption: localize.getString("phone"),
    },
    {
      type: "buttons",
      width: 110,
      buttons: [
        {
          hint: "Detaya git",
          icon: "info",
          onClick: async (e: any) => {
            completedId.current.contactId = e.row.data.Id;
            const response: ApiResponse<PendingContacts> = await createRequest({
              method: "GET",
              url: "/api/admin/contacts/" + e.row.data.Id,
              bodyType: BodyType.formdata,
              token,
              body: {},
              lang,
            });
            if (verfiyResponse(response)) {
              setData(response.Result);
            }
            setShow(true);
          },
        },
      ],
    },
  ];

  return (
    <>
      {" "}
      <Modal
        visible={show}
        onHiding={() => {
          setShow(false);
        }}
        title={localize.getString("contactDetail")}
        width="30%"
        buttonTitle="Tamamlandı"
        height="50%"
        onSubmitClick={async () => {
          const response: ApiResponse = await createRequest({
            method: "POST",
            url: "/api/admin/contacts",
            bodyType: BodyType.raw,
            token,
            body: completedId.current,
            lang,
          });
          if (verfiyResponse(response)) {
            notify(response.Message, "success");
            setShow(false);
          } else {
            notify(response.Message, "danger");
          }
        }}
      >
        <PendingContactsDetail
          data={data}
          complete={completedId.current}
        ></PendingContactsDetail>
      </Modal>
      <div className="dx-card" style={{ backgroundColor: "white" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "start",
            fontSize: "16px",
            fontWeight: 700,
            paddingInline: 10,
            marginBlock: "5px 5px",
          }}
        >
          <p style={{ color: "#434D6E" }}>İletişim Talepleri</p>
          <Button
            hint={"Yenile"}
            icon="refresh"
            type="normal"
            stylingMode="outlined"
            onClick={() => tableRef?.current?._instance?.refresh()}
          />
        </div>
        <div className="grid-div">
          <ScrollView>
            <DataGrid
              ref={tableRef}
              style={{ fontSize: 12 }}
              key="Id"
              className={"custom-data-grid wide-card dashboard-grid"}
              dataSource={
                new CustomStore({
                  key: "Id",
                  //@ts-ignore
                  load: () =>
                    baseService.sendRequest(
                      adminPendingContacts,
                      "GET",
                      token,
                      "tr-TR"
                    ),
                })
              }
              showBorders
              showRowLines
              showColumnLines={false}
              columnAutoWidth
              columnHidingEnabled
              rowAlternationEnabled
              allowColumnResizing
              allowColumnReordering
              focusedRowEnabled
              grouping={{
                autoExpandAll: false,
              }}
            >
              {columns.map((column, i) => (
                <Column key={i} {...column} />
              ))}
            </DataGrid>
          </ScrollView>
        </div>
      </div>
    </>
  );
};

export default PendingContact;
